import { LineReveal } from "@/components/Reveal";

export const PageHero = ({ eyebrow, title, subtitle, testId }) => (
  <section className="bg-navy relative grain overflow-hidden pt-36 pb-20 md:pt-44 md:pb-28" data-testid={testId}>
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative z-10">
      <div className="font-mono text-xs tracking-[0.3em] text-emerald mb-6">{eyebrow}</div>
      <h1 className="font-display font-black text-white text-6xl md:text-8xl tracking-tighter leading-[0.9]">
        <LineReveal lines={Array.isArray(title) ? title : [title]} />
      </h1>
      {subtitle && <p className="text-white/60 mt-8 max-w-xl text-lg leading-relaxed">{subtitle}</p>}
    </div>
  </section>
);
